import { sendAdminRequest } from '../../api/websocketApi';
import { LabProcessStatus } from '../../hooks/useKits';
import useStore from '../../store/store';

interface UpdateLabProcessStatusParams {
    kitId: number;
    labProcessStatus: LabProcessStatus;
}

interface APIResponse {
    success: boolean;
    errCode?:
        | 'invalid_param'
        | 'invalid_token'
        | 'auth_failed'
        | 'access_denied';
    errDetails?: string;
}

const UpdateLabProcessStatus = (params: UpdateLabProcessStatusParams) => {
    const setFormError = useStore.getState().setFormError;
    const setIsLoading = useStore.getState().setIsLoading;

    setIsLoading(true);
    sendAdminRequest(
        {
            endpoint: '/kit/update-lab-process-status',
            body: params,
        },
        (data: APIResponse) => {
            const { success, errCode, errDetails } = data;
            if (success) {
                setIsLoading(false);
            } else if (!success && errCode) {
                setIsLoading(false);
                setFormError('');
                setTimeout(() => setFormError(errCode), 0);
                console.error(errCode);
                if (errDetails) console.error(errDetails);
            }
        }
    );
};

export default UpdateLabProcessStatus;
